var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHappy = function SvgHappy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
    fill: "#F7B239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69519 18.3047C1.37845 13.9878 1.03829 7.2005 4.67446 2.49414C4.27167 2.80529 3.88411 3.14546 3.51465 3.51492C-1.17155 8.20112 -1.17155 15.799 3.51465 20.4852C8.20085 25.1713 15.7987 25.1714 20.4849 20.4852C20.8543 20.1157 21.1945 19.7281 21.5057 19.3253C16.7994 22.9616 10.012 22.6214 5.69519 18.3047Z",
    fill: "#E09B2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77344 12.8613H17.8713C17.8713 13.5403 17.7592 14.1933 17.5528 14.8029H6.0919C5.88551 14.1933 5.77344 13.5403 5.77344 12.8613Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0918 14.8027H17.5527C17.1459 16.0042 16.372 17.0355 15.3644 17.7643C14.941 17.0509 14.163 16.5729 13.2728 16.5729C12.729 16.5729 12.2273 16.7514 11.8223 17.0533C11.4172 16.7514 10.9149 16.5729 10.3711 16.5729C9.4816 16.5729 8.70292 17.0509 8.28012 17.7643C7.27256 17.0355 6.49862 16.0042 6.0918 14.8027Z",
    fill: "#A81004"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2721 16.5732C14.1622 16.5732 14.9403 17.0512 15.3637 17.7646C14.368 18.4858 13.1439 18.9104 11.8215 18.9104C10.499 18.9104 9.275 18.4858 8.2793 17.7646C8.70215 17.0512 9.48078 16.5732 10.3703 16.5732C10.9141 16.5732 11.4164 16.7517 11.8214 17.0536C12.2266 16.7517 12.7283 16.5732 13.2721 16.5732Z",
    fill: "#F95428"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68858 11.1584C7.59597 11.1584 8.33419 10.4202 8.33419 9.5128C8.33419 8.60541 7.59597 7.86719 6.68858 7.86719C5.78119 7.86719 5.04297 8.60541 5.04297 9.5128C5.04297 10.4202 5.78119 11.1584 6.68858 11.1584Z",
    fill: "#223137"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3136 7.86719C16.4062 7.86719 15.668 8.60541 15.668 9.5128C15.668 10.4202 16.4062 11.1584 17.3136 11.1584C18.221 11.1584 18.9592 10.4202 18.9592 9.5128C18.9592 8.60541 18.2209 7.86719 17.3136 7.86719Z",
    fill: "#223137"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happy.116c46cb.svg";
export { ForwardRef as ReactComponent };